import { html } from "lit";
import { sizes } from "../SelectBase/index.js";
import "../SelectButton/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { prop } from "../../../decorators/prop/index.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { preventDefault } from "../../../decorators/preventDefault.js";
import { stringArrayConverter } from "../attribute-converters.js";
import { stringOrStringArrayHasChanged } from "../change-detection.js";
import { testingAttr } from "../../../directives/testingAttr.js";
import { TestingAttrs } from "./select.selectors.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfSelect = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.value = [];
    this.disabled = false;
    this.dsf_open = false;
    this.dsf_error = false;
    this.dsf_success = false;
    this.dsf_size = "medium";
    this.dsf_flip = true;
    this.dsf_shift = true;
    this.dsf_hide = false;
    this.dsf_multiselect = false;
    this.dsf_show_close_button = false;
    this.dsf_searching = false;
    this.dsf_search_error = false;
    this.dsf_selected_first = false;
    this.dsf_open_on_focus = false;
  }
  handleChange(ev) {
    if (this.dsf_multiselect) {
      this.value = ev.detail;
    } else {
      this.value = ev.detail.length ? ev.detail[0] : void 0;
    }
    this.emit({ name: "input", payload: this.value });
    this.emit({ name: "change", payload: this.value });
  }
  handleOpenChanged(ev) {
    this.dsf_open = ev.detail;
  }
  handleTagUnselect(ev) {
    const newValue = Array.isArray(this.value) ? [...this.value] : [];
    newValue.splice(ev.detail, 1);
    this.value = newValue;
    this.emit({ name: "input", payload: this.value });
    this.emit({ name: "change", payload: this.value });
  }
  render() {
    const baseValue = Array.isArray(this.value) ? this.value : this.value ? [this.value] : [];
    return html`
      <dsf-select-base
        exportparts="dropdown,list"
        .value=${baseValue}
        .disabled=${this.disabled}
        .dsf_open=${this.dsf_open}
        .dsf_label=${this.dsf_label}
        .dsf_size=${this.dsf_size}
        .dsf_multiselect=${this.dsf_multiselect}
        .dsf_show_close_button=${this.dsf_show_close_button}
        .dsf_search_type=${this.dsf_search_type}
        .dsf_searching=${this.dsf_searching}
        .dsf_search_placeholder=${this.dsf_search_placeholder}
        .dsf_search_message=${this.dsf_search_message}
        .dsf_search_error=${this.dsf_search_error}
        .dsf_title_text=${this.dsf_title_text}
        .dsf_clear_button_text=${this.dsf_clear_button_text}
        .dsf_apply_button_text=${this.dsf_apply_button_text}
        .dsf_flip=${this.dsf_flip}
        .dsf_shift=${this.dsf_shift}
        .dsf_hide=${this.dsf_hide}
        .dsf_error=${this.dsf_error}
        .dsf_success=${this.dsf_success}
        .dsf_message=${this.dsf_message}
        .dsf_no_results_text=${this.dsf_no_results_text}
        .dsf_select_all_text=${this.dsf_select_all_text}
        .dsf_selected_first=${this.dsf_selected_first}
        .dsf_open_on_focus=${this.dsf_open_on_focus}
        dsf_same_width
        @change=${this.handleChange}
        @open-changed=${this.handleOpenChanged}
      >
        <dsf-select-button
          slot="button"
          exportparts="select-button"
          .disabled=${this.disabled}
          .dsf_multiselect=${this.dsf_multiselect}
          .dsf_error=${this.dsf_error}
          .dsf_success=${this.dsf_success}
          .dsf_open=${this.dsf_open}
          .dsf_size=${this.dsf_size}
          .dsf_placeholder=${this.dsf_placeholder}
          ${testingAttr(TestingAttrs.selectButton)}
          @tag-unselect=${this.handleTagUnselect}
        >
        </dsf-select-button>
        <slot></slot>
      </dsf-select-base>
    `;
  }
};
__decorateClass([
  prop({
    type: String,
    reflect: true,
    converter: stringArrayConverter,
    hasChanged: stringOrStringArrayHasChanged
  })
], DsfSelect.prototype, "value", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfSelect.prototype, "disabled", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfSelect.prototype, "dsf_open", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfSelect.prototype, "dsf_error", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfSelect.prototype, "dsf_success", 2);
__decorateClass([
  prop({ type: String })
], DsfSelect.prototype, "dsf_placeholder", 2);
__decorateClass([
  prop({ type: String })
], DsfSelect.prototype, "dsf_message", 2);
__decorateClass([
  prop({ type: String })
], DsfSelect.prototype, "dsf_label", 2);
__decorateClass([
  prop({ type: String, reflect: true, validator: (value) => sizes.includes(value) })
], DsfSelect.prototype, "dsf_size", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfSelect.prototype, "dsf_flip", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfSelect.prototype, "dsf_shift", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfSelect.prototype, "dsf_hide", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfSelect.prototype, "dsf_multiselect", 2);
__decorateClass([
  prop({ type: String })
], DsfSelect.prototype, "dsf_title_text", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfSelect.prototype, "dsf_show_close_button", 2);
__decorateClass([
  prop({ type: String })
], DsfSelect.prototype, "dsf_clear_button_text", 2);
__decorateClass([
  prop({ type: String })
], DsfSelect.prototype, "dsf_apply_button_text", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfSelect.prototype, "dsf_search_type", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfSelect.prototype, "dsf_searching", 2);
__decorateClass([
  prop({ type: String })
], DsfSelect.prototype, "dsf_search_placeholder", 2);
__decorateClass([
  prop({ type: String })
], DsfSelect.prototype, "dsf_search_message", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfSelect.prototype, "dsf_search_error", 2);
__decorateClass([
  prop({ type: String })
], DsfSelect.prototype, "dsf_no_results_text", 2);
__decorateClass([
  prop({ type: String })
], DsfSelect.prototype, "dsf_select_all_text", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfSelect.prototype, "dsf_selected_first", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfSelect.prototype, "dsf_open_on_focus", 2);
__decorateClass([
  preventDefault
], DsfSelect.prototype, "handleChange", 1);
DsfSelect = __decorateClass([
  defineElement("dsf-select")
], DsfSelect);
export {
  DsfSelect
};
